import ReactSwitch from "react-switch";

import Icon from "../../Utils/Icon";

const AnonymousContributionSwitch = ({ anonymous, handleAnonymousChange }) => {
  return (
    <div
      className="switch-container d-flex align-items-center"
      data-anonymous-contribution-checkbox
      data-toggle-anonymous-mode-button
    >
      <Icon className="fa margin-right-xs fa-user" />

      <ReactSwitch
        onChange={handleAnonymousChange}
        checked={anonymous}
        checkedIcon={false}
        uncheckedIcon={false}
        onColor="#999"
        offColor="#999"
      />

      <Icon className="fa margin-left-xs fa-user-secret" />
    </div>
  );
};

export default AnonymousContributionSwitch;
